module.exports = __webpack_public_path__ + "media/images/pic/hero/woman-66709a15d1f80ecc2716cacd4e970e28.png";